import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function WhatYouGet() {
  return <section className="py-24 px-4 bg-white" data-id="element-134">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="order-2 lg:order-1" data-id="element-136">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-137">
            <img src="https://cdn.magicpatterns.com/uploads/4wX36VYVHbiaaC46bef1zo/heylloyd-image-1770073766048.png" alt="The 3AM Wake-Up Reset Kit" className="w-full h-auto" data-id="element-138" />
          </div>
        </motion.div>

        <div className="order-1 lg:order-2 space-y-8" data-id="element-139">
          <h2 className="text-3xl md:text-4xl font-serif text-[#1e2a38]" data-id="element-140">
            What you get inside
          </h2>

          <div className="space-y-8" data-id="element-141">
            <div className="bg-[#f5f0e8] p-6 rounded-xl border border-[#1e2a38]/10" data-id="element-142">
              <h3 className="text-xl font-bold text-[#1e2a38] mb-2" data-id="element-143">
                1. The PDF Guide (40–60 pages)
              </h3>
              <ul className="space-y-2 text-gray-700" data-id="element-144">
                <li className="flex items-start gap-2" data-id="element-145">
                  <Check className="w-5 h-5 text-[#c9a07a] mt-0.5" data-id="element-146" />
                  <span data-id="element-147">The 60-second trigger diagnosis</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-148">
                  <Check className="w-5 h-5 text-[#c9a07a] mt-0.5" data-id="element-149" />
                  <span data-id="element-150">
                    The four 5-minute protocols (Heat / Pee / Cortisol / Spiral)
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-151">
                  <Check className="w-5 h-5 text-[#c9a07a] mt-0.5" data-id="element-152" />
                  <span data-id="element-153">The 7-night installation plan</span>
                </li>
              </ul>
            </div>

            <div className="bg-[#1e2a38] p-6 rounded-xl text-white shadow-lg transform scale-105" data-id="element-154">
              <h3 className="text-xl font-bold text-[#c9a07a] mb-2" data-id="element-155">
                2. The Bedside Decision Card
              </h3>
              <p className="text-gray-300" data-id="element-156">
                So you don't have to remember anything at 3AM. You wake up →
                glance → do the next right step.
              </p>
            </div>

            <div className="bg-[#f5f0e8] p-6 rounded-xl border border-[#1e2a38]/10" data-id="element-157">
              <h3 className="text-xl font-bold text-[#1e2a38] mb-2" data-id="element-158">
                3. The 7-Night Tracker
              </h3>
              <p className="text-gray-700" data-id="element-159">
                Turns "I don't know what's happening" into clear data. Clarity
                lowers panic.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}